// const pinpadUrl = 'https://pinpadmock.free.beeceptor.com/start-transaction'
const pinpadUrl = 'http://localhost:3000/start-transaction'
const pinpadAuth = '123'
const version = 12

export { pinpadUrl, pinpadAuth, version }
